<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="header mt-md-5">
                    <div class="header-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="header-pretitle">{{$t('Store')}}</h6>
                                <h1 class="header-title">{{$t('Brands')}}</h1>
                            </div>
                            <div class="col-auto">
                                <button
                                    @click="openModal({id:'brandFormModal', model:categoryDefaults})"
                                    class="btn btn-primary"
                                >{{$t('Add brand')}}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Card -->
                <div class="card" data-toggle="lists">
                    <div class="card-header">
                        <div class="row align-items-center">
                            <div class="col">
                                <!-- Search -->
                                <div class="row align-items-center">
                                    <div class="col-auto pr-0">
                                        <span class="fe fe-x text-muted" v-if="query" @click="query=null"></span>
                                        <span class="fe fe-search text-muted" v-else></span>
                                    </div>
                                    <div class="col">
                                        <input
                                            type="search"
                                            v-model="query"
                                            class="form-control form-control-flush search no-glow"
                                            :placeholder="$t('Search')"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- / .row -->
                    </div>

                    <simple-table
                        :data="items"
                        :onSort="setSort"
                        :loading="areCategoriesLoading"
                        :edit="edit"
                        :deleteItem="deleteItem"
                        :columns="columns"
                        :hideDeleteButton="true"
                        :sort="sort"
                    ></simple-table>
                </div>
                <div class="mt-3 text-center" v-if="totalRows > perPage">
                    <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="perPage" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable.vue';
import { modalMixins } from '@/mixins/modal.js';
import { mapActions, mapGetters, mapState } from 'vuex';
import debounce from 'lodash/debounce';

export default {
    mixins: [modalMixins],
    components: {
        SimpleTable,
    },
    data() {
        return {
            categoryDefaults: {
            },
            query: null,
            params: {
                query: {
                    $limit: 1000,

                }
            },
            currentPage: 1,
            perPage: 100,
            totalRows: 0,
            sort: 'createdAt',
            order: -1,
            model: {},
            errors: {},
            columns: [
                {
                    label: 'Label',
                    name: 'label',
                    sortable: true,
                },
            ],
        };
    },
    computed: {
        ...mapState('brands', { areCategoriesLoading: 'isFindPending' }),
        ...mapGetters('brands', {
            findBrandsInStore: 'find'
        }),
        items() {
            return this.findBrandsInStore({ query: Object.assign({ _id: { $ne: 'temp' } }, this.params.query) }).data;
        }
    },
    watch: {
        query: debounce(function (newVal) {
            if (newVal) {
                this.params.query.$or = [
                    { label: { $regex: newVal, $options: "i" } },
                ];
            } else {
                delete this.params.query.$or;
            }

            this.fetchItems();

        }, 400),
        currentPage: debounce(function (newVal) {

        }, 400),

    },
    created() {
        this.fetchItems();
    },
    methods: {
        ...mapActions('brands', ['find', 'remove', 'create', 'patch']),
        setSort(field, order) {
            this.sort = field;
            this.order = order;
            this.fetchItems();
        },
        edit(model) {
            let brand = {
                model,
                _id: 'temp'
            };
            const { Brand } = this.$FeathersVuex;
            new Brand(brand);
            this.openModal({ id: 'brandFormModal', model: model })
        },
        deleteItem(item) {
            this.remove(item._id).then(data => {
                this.$toasted.global.success({
                    message: this.$t('Brand deleted')
                });
            })
        },
        fetchItems() {
            this.find(this.params).then(data => {
                this.totalRows = data.total;
            });
        },
    }
}
</script>
